import appAxios from 'api/appAxios';
import { AUTH_STATUS } from 'api/urls/auth';

const isUserAuthenticated = async () => {
  return await appAxios.get(AUTH_STATUS);
};

export default isUserAuthenticated;
